import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import SpGoogleMarker from "./googleMaps/SpGoogleMarker";
import { SpGoogleSearchBox } from "./googleMaps/SpGoogleSearchBox";

const AnyReactComponent = ({ text }) => <div>{text}</div>;

const SpGoogleMap = (props) => {
	const center = {
		lat: 43.16296,
		lng: 13.72274,
	};

	const { handleMarkerClicked, onClick } = props;

	const MapMarker = props.CustomMarker ? props.CustomMarker : SpGoogleMarker;
	return (
		// Important! Always set the container height explicitly
		<div style={{ height: "65vh", width: "100%", position: "relative" }}>
			<SpGoogleSearchBox onPlaceSelected={onClick} />
			<GoogleMapReact onClick={(obj) => onClick(obj)} bootstrapURLKeys={{ key: "AIzaSyC0KvC-l9aD8fS42m3aVZytFL893tMCw4A", libraries: "places" }} defaultCenter={center} defaultZoom={11}>
				{props.markers.map((elem, idx) => (
					<MapMarker lat={elem.lat} lng={elem.lng} key={idx} markerData={elem} onClick={() => handleMarkerClicked(elem)} />
				))}
			</GoogleMapReact>
		</div>
	);
};

export default SpGoogleMap;
